import { swRequest } from "@sourcewhale/core";

export const getContactRecords = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/activities/get_contact_records",
      method: "POST",
      body,
    },
    opts,
  );

export const getProfileRecords = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/activities/get_profile_records",
      method: "POST",
      body,
    },
    opts,
  );

export const fillFeedActivities = (params, opts = {}) =>
  swRequest(
    {
      path: `/api/activities/fill_feed`,
      method: "GET",
      params,
    },
    opts,
  );

export const getTrackingActivities = (params, opts = {}) =>
  swRequest(
    {
      path: `/api/activities/get_tracking`,
      method: "GET",
      params,
    },
    opts,
  );
